import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useTheme } from "../../context/ThemeContext";
import { auth } from "../../firebase/config";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import OnboardingWizard from "../../components/OnboardingWizard";

const ROLES = {
  gestion_general: "Gestión General",
  recepcion: "Recepción",
  medico: "Médico",
  administracion: "Administración",
  superadmin: "Super Admin"
};

const MODULOS = {
  gestion_general: [
    { nombre: "Agenda", icono: "ti-calendar", ruta: "/agenda" },
    { nombre: "Pacientes", icono: "ti-users", ruta: "/pacientes" },
    { nombre: "Caja", icono: "ti-cash", ruta: "/caja" },
    { nombre: "Prestadores", icono: "ti-building-hospital", ruta: "/prestadores" },
    { nombre: "Inventario", icono: "ti-package", ruta: "/inventario" },
    { nombre: "Métricas", icono: "ti-chart-bar", ruta: "/metricas" },
    { nombre: "Consentimientos", icono: "ti-file-check", ruta: "/consentimientos" },
    { nombre: "Presupuestos", icono: "ti-file-invoice", ruta: "/presupuestos" },
    { nombre: "Financiación", icono: "ti-chart-line", ruta: "/financiacion" },
    { nombre: "Honorarios", icono: "ti-award", ruta: "/honorarios" },
    { nombre: "Derivaciones", icono: "ti-link", ruta: "/derivaciones" },
    { nombre: "Portal Paciente", icono: "ti-device-mobile", ruta: "/gestion-portal" },
    { nombre: "Usuarios", icono: "ti-settings", ruta: "/usuarios" },
    { nombre: "Configuración", icono: "ti-adjustments", ruta: "/configuracion" },
    { nombre: "Centro de Ayuda", icono: "ti-help-circle", ruta: "/ayuda" },
  ],
  recepcion: [
    { nombre: "Agenda", icono: "ti-calendar", ruta: "/agenda" },
    { nombre: "Pacientes", icono: "ti-users", ruta: "/pacientes" },
    { nombre: "Caja", icono: "ti-cash", ruta: "/caja" },
    { nombre: "Consentimientos", icono: "ti-file-check", ruta: "/consentimientos" },
    { nombre: "Presupuestos", icono: "ti-file-invoice", ruta: "/presupuestos" },
    { nombre: "Financiación", icono: "ti-chart-line", ruta: "/financiacion" },
    { nombre: "Portal Paciente", icono: "ti-device-mobile", ruta: "/gestion-portal" },
    { nombre: "Métricas", icono: "ti-chart-bar", ruta: "/metricas" },
    { nombre: "Centro de Ayuda", icono: "ti-help-circle", ruta: "/ayuda" },
  ],
  medico: [
    { nombre: "Agenda", icono: "ti-calendar", ruta: "/agenda" },
    { nombre: "Pacientes", icono: "ti-users", ruta: "/pacientes" },
    { nombre: "Consentimientos", icono: "ti-file-check", ruta: "/consentimientos" },
    { nombre: "Presupuestos", icono: "ti-file-invoice", ruta: "/presupuestos" },
    { nombre: "Financiación", icono: "ti-chart-line", ruta: "/financiacion" },
    { nombre: "Portal Paciente", icono: "ti-device-mobile", ruta: "/gestion-portal" },
    { nombre: "Métricas", icono: "ti-chart-bar", ruta: "/metricas" },
    { nombre: "Honorarios", icono: "ti-award", ruta: "/honorarios" },
    { nombre: "Centro de Ayuda", icono: "ti-help-circle", ruta: "/ayuda" },
  ],
  administracion: [
    { nombre: "Caja", icono: "ti-cash", ruta: "/caja" },
    { nombre: "Arqueos", icono: "ti-report-money", ruta: "/caja/arqueo" },
    { nombre: "Prestadores", icono: "ti-building-hospital", ruta: "/prestadores" },
    { nombre: "Inventario", icono: "ti-package", ruta: "/inventario" },
    { nombre: "Métricas", icono: "ti-chart-bar", ruta: "/metricas" },
    { nombre: "Pacientes", icono: "ti-users", ruta: "/pacientes" },
    { nombre: "Presupuestos", icono: "ti-file-invoice", ruta: "/presupuestos" },
    { nombre: "Financiación", icono: "ti-chart-line", ruta: "/financiacion" },
    { nombre: "Honorarios", icono: "ti-award", ruta: "/honorarios" },
    { nombre: "Derivaciones", icono: "ti-link", ruta: "/derivaciones" },
    { nombre: "Centro de Ayuda", icono: "ti-help-circle", ruta: "/ayuda" },
  ],
  superadmin: [
    { nombre: "Clínicas", icono: "ti-building-hospital", ruta: "/superadmin/clinicas" },
    { nombre: "Usuarios", icono: "ti-users", ruta: "/superadmin/usuarios" },
    { nombre: "Métricas globales", icono: "ti-chart-bar", ruta: "/superadmin/metricas" },
    { nombre: "Facturación", icono: "ti-cash", ruta: "/superadmin/facturacion" },
    { nombre: "Analítica", icono: "ti-chart-dots", ruta: "/superadmin/analitica" },
  ],
};

export default function Dashboard() {
  const { currentUser, userRole, clinicaId, clinicaData, isSuperAdmin } = useAuth();
  const { theme, isDark, toggleTheme } = useTheme();
  const navigate = useNavigate();
  const [onboardingListo, setOnboardingListo] = useState(false);

  async function handleLogout() {
    await signOut(auth);
    navigate("/");
  }

  const modulos = MODULOS[userRole] || [];
  const nombreClinica = clinicaData?.nombre || (isSuperAdmin ? "Super Admin" : "");
  const necesitaOnboarding = !isSuperAdmin && userRole === 'gestion_general' && !clinicaData?.onboardingCompletado && !onboardingListo && clinicaData?.estado !== 'pendiente_activacion';

  if (clinicaData?.estado === 'pendiente_activacion') {
    return (
      <div style={{ minHeight: "100vh", background: theme.bg, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Montserrat', sans-serif" }}>
        <div style={{ textAlign: "center", maxWidth: "420px", padding: "40px" }}>
          <img src="/Logotipo-Deluxe.png" alt="Deluxe Software" style={{ height: "56px", width: "auto", marginBottom: "32px" }} />
          <div style={{ fontSize: "48px", marginBottom: "16px" }}>⏳</div>
          <div style={{ fontSize: "20px", fontWeight: "700", color: theme.primary, marginBottom: "12px" }}>Tu cuenta está siendo activada</div>
          <div style={{ fontSize: "14px", color: theme.secondary, lineHeight: "1.6", marginBottom: "24px" }}>
            Recibimos tu registro correctamente. En menos de 24 horas vas a recibir un correo confirmando el acceso a tu período de prueba gratuito de 30 días.
          </div>
          <div style={{ fontSize: "13px", color: theme.accent, marginBottom: "32px" }}>{currentUser?.email}</div>
          <button onClick={handleLogout} style={{ background: "transparent", border: `0.5px solid ${theme.borderInput}`, borderRadius: "8px", padding: "10px 24px", color: theme.secondary, fontSize: "13px", cursor: "pointer", fontFamily: "'Montserrat', sans-serif" }}>
            Cerrar sesión
          </button>
        </div>
      </div>
    );
  }

  if (clinicaData?.estado === 'suspendida') {
    return (
      <div style={{ minHeight: "100vh", background: theme.bg, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Montserrat', sans-serif" }}>
        <div style={{ textAlign: "center", maxWidth: "420px", padding: "40px" }}>
          <img src="/Logotipo-Deluxe.png" alt="Deluxe Software" style={{ height: "56px", width: "auto", marginBottom: "32px" }} />
          <div style={{ fontSize: "48px", marginBottom: "16px" }}>⚠️</div>
          <div style={{ fontSize: "20px", fontWeight: "700", color: theme.primary, marginBottom: "12px" }}>Tu cuenta está suspendida</div>
          <div style={{ fontSize: "14px", color: theme.secondary, lineHeight: "1.6", marginBottom: "24px" }}>
            Tu período de prueba ha vencido o tu suscripción está inactiva. Contactanos para reactivar tu cuenta.
          </div>
          <a href="mailto:admin@deluxesoftware.com.ar" style={{ display: "inline-block", padding: "12px 24px", fontSize: "13px", fontWeight: "600", background: `linear-gradient(135deg, ${theme.accent}, ${theme.accentDark})`, color: "#FFFFFF", borderRadius: "8px", textDecoration: "none", fontFamily: "'Montserrat', sans-serif", marginBottom: "12px" }}>
            Contactar soporte
          </a>
          <div>
            <button onClick={handleLogout} style={{ background: "transparent", border: "none", color: theme.secondary, fontSize: "13px", cursor: "pointer", fontFamily: "'Montserrat', sans-serif" }}>
              Cerrar sesión
            </button>
          </div>
        </div>
      </div>
    );
  }
  if (necesitaOnboarding) {
    return (
      <OnboardingWizard onCompletado={() => setOnboardingListo(true)} />
    );
  }

  return (
    <div style={{ minHeight: "100vh", background: theme.bg, fontFamily: "'Montserrat', sans-serif" }}>
      <div style={{
        background: theme.bgHeader,
        borderBottom: `0.5px solid ${theme.borderHeader}`,
        padding: "0 32px",
        display: "flex", alignItems: "center", justifyContent: "space-between",
        height: "60px"
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <img src="/Isotipo-Deluxe.png" alt="Deluxe" style={{ height: "46px", width: "auto" }} />
          {nombreClinica && (
            <>
              <div style={{ width: "1px", height: "20px", background: theme.border }} />
              <span style={{ color: "#FFFFFF", fontSize: "13px", fontWeight: "500" }}>{nombreClinica}</span>
            </>
          )}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div style={{ textAlign: "right" }}>
            <div style={{ color: "#FFFFFF", fontSize: "13px", fontWeight: "500" }}>{currentUser?.email}</div>
            <div style={{ color: theme.accent, fontSize: "11px", letterSpacing: "0.5px" }}>{ROLES[userRole] || userRole}</div>
          </div>
          <button onClick={toggleTheme} title={isDark ? "Tema claro" : "Tema oscuro"} style={{ background: "none", border: `0.5px solid rgba(255,255,255,0.3)`, borderRadius: "8px", padding: "5px 10px", cursor: "pointer", fontSize: "16px", lineHeight: 1 }}>
            {isDark ? "☀️" : "🌙"}
          </button>
          <button onClick={handleLogout} style={{ background: "none", border: "0.5px solid rgba(255,255,255,0.3)", borderRadius: "8px", padding: "6px 14px", color: "#FFFFFF", fontSize: "12px", cursor: "pointer", fontFamily: "'Montserrat', sans-serif" }}>
            Salir
          </button>
        </div>
      </div>

      <div style={{ padding: "40px 32px" }}>
        <div style={{ marginBottom: "32px" }}>
          <div style={{ fontSize: "22px", fontWeight: "700", color: theme.primary, marginBottom: "4px" }}>
            {isSuperAdmin ? "Panel de administración" : `Bienvenido${nombreClinica ? ` a ${nombreClinica}` : ""}`}
          </div>
          <div style={{ fontSize: "13px", color: theme.secondary }}>
            {ROLES[userRole]} · Seleccioná un módulo para comenzar
          </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: "16px" }}>
          {modulos.map((modulo) => (
            <div
              key={modulo.nombre}
              onClick={() => navigate(modulo.ruta)}
              style={{
                background: theme.bgCard,
                borderRadius: "12px", padding: "24px 20px",
                border: `0.5px solid ${theme.border}`,
                cursor: "pointer", transition: "all 0.2s", textAlign: "center",
              }}
              onMouseEnter={e => {
                e.currentTarget.style.borderColor = theme.accent;
                e.currentTarget.style.background = theme.bgCardHover;
              }}
              onMouseLeave={e => {
                e.currentTarget.style.borderColor = theme.border;
                e.currentTarget.style.background = theme.bgCard;
              }}
            >
              <i className={`ti ${modulo.icono}`} style={{ fontSize: "28px", color: theme.accent, marginBottom: "10px", display: "block" }}></i>
              <div style={{ fontSize: "13px", fontWeight: "500", color: theme.primary }}>
                {modulo.nombre}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div style={{ textAlign: 'center', padding: '24px 0 8px', fontSize: '12px', color: theme.secondary }}>
  Ante cualquier duda o consulta contactanos a <a href="mailto:notificaciones@deluxesoftware.com.ar" style={{ color: theme.accent, textDecoration: 'none' }}>notificaciones@deluxesoftware.com.ar</a>
</div>
    </div>
  );
}